import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function TextField(theme: Theme) {
  return {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& MuiInputBase-root': {
            input: {
              input: {
                '&.Mui-disabled': {
                  color: '#000000',
                },
              },
            },
          },
          '& .MuiFilledInput-root': {
            '&.Mui-disabled': {
              backgroundColor: 'rgba(145, 158, 171, 0.025)',
              input: {
                WebkitTextFillColor: '#000000'
              },
            },
          }
        },
      }
    }
  }
}
